import "./style.scss";

import { validate, validateEmail, validatePhone } from "../../../../utils/validate";
import { CONFIG_FIELDS } from "./constant";
import { setTranslateElement } from "../../../../utils/language";

export function setUpFormLP(options = {}, onSubmit) {
  let selector = options.selector || "";
  $(`${selector} .form-landingpage .form-group`).addClass("hide");
  if (options.icon) {
    $(`${selector} .form-landingpage .icon-form`).attr("src", options.icon)
  }
  if (options.title) {
    setTranslateElement({
      element: $(`${selector} .form-landingpage .title-form`),
      i18nKey: options.title,
      isHtml: true
    })
  }
  if (options.subTitle) {
    setTranslateElement({
      element: $(`${selector} .form-landingpage .sub-title`),
      i18nKey: options.subTitle,
      isHtml: true
    })
  }
  if (options.fields) {
    let htmlForm = ""
    options.fields.forEach((field, index) => {
      let temp = CONFIG_FIELDS[field.name];
      temp.required = field.required !== false;
      htmlForm += genInputHtml(temp, index + 1)
    });
    $(`${selector} .form-landingpage form .form-input`).html(htmlForm);
    $(`${selector} .form-landingpage form .form-input select`).each(function (i, obj) {
      $(obj).selectize({
        onChange: function (value) {
          $(".option", this.$dropdown_content).removeClass("selected");
          validate({ selector: `${selector} .form-landingpage .${$(obj).attr("name")} select` });
        }
      });
    });
    $(`${selector} .form-landingpage`).removeClass("hide")
  } else {
    $(`${selector} .form-landingpage`).addClass("hide")
  }

  $(`${selector} .form-landingpage .form-group input, ${selector} .form-landingpage .form-group textarea`).off("change");
  $(`${selector} .form-landingpage .form-group input, ${selector} .form-landingpage .form-group textarea`).on("change", function (e) {
    let name = e.target.name;
    let required = $(this).data("required");
    let config = CONFIG_FIELDS[name];

    if (required !== false) {
      validate({ selector: `${selector} .form-landingpage .${config.name} ${config.type}` });
    }
  });

  if (options.button) {
    setTranslateElement({
      element: $(`${selector} .form-landingpage .btn-submit`),
      i18nKey: options.button,
    })
  }
  if (onSubmit && typeof (onSubmit) === "function") {
    $(`${selector} .form-landingpage .btn-submit`).off("click");
    $(`${selector} .form-landingpage .btn-submit`).on("click", function (e) {
      e.preventDefault();
      const apiTime = Date.now();
      window.apiTime = apiTime;
      if (validateForm(options)) {
        onSubmit(getParams(options), {
          onSuccess: (data) => onSuccess(options, data),
          onError: (data) => onSuccess(options, data)
        },
          apiTime);
      }
    });
    $(`${selector} .form-landingpage .btn-submit`).removeClass("hide")
  } else {
    $(`${selector} .form-landingpage .btn-submit`).addClass("hide")
  }
}

function getParams(options) {
  let params = {
    ticket_type: options.type,
    meta: {}
  }
  options.fields.forEach(field => {
    let temp = CONFIG_FIELDS[field.name];
    params.meta[temp.key] = $(`${options.selector} .form-landingpage .form-group.${temp.name} ${temp.type}`).val()
  });
  return params
}

const onSuccess = (options, data) => {
  let selector = options.selector || "";
  $(`${selector} .form-landingpage .message`).show();
  setTimeout(function () {
    $(`${selector} .form-landingpage .message`).hide();
  }, 3000);
  onReset(selector);
}

const onReset = (selector) => {
  $(`${selector} .form-landingpage .form-group input`).val("")
  $(`${selector} .form-landingpage .form-group textarea`).val("")
  $(`${selector} .form-landingpage .form-input select`).each(function (i, obj) {
    $(obj)[0].selectize.setValue("", true);
  });
}

const validateForm = (options) => {
  let selector = options.selector || "";
  let result = true;
  if (options.fields) {
    options.fields.forEach(field => {
      let temp = CONFIG_FIELDS[field.name];
      if (field.required !== false) {
        result &= validate({ selector: `${selector} .form-landingpage .${temp.name} ${temp.type}`, isFocus: result });
      }
      switch (temp.typeInput) {
        case "email":
          result &= validate({ selector: `${selector} .form-landingpage .${temp.name} ${temp.type}`, validator: validateEmail, isFocus: result });
          break;
        case "phone":
          result &= validate({ selector: `${selector} .form-landingpage .${temp.name} ${temp.type}`, validator: validatePhone, isFocus: result });
          break;
        default:
          break;
      }
    });
  }
  return result;
}

function genInputHtml(element, index) {
  let htmlOptions = "";
  if (element.type === "select" && element.options && element.options.length > 0) {
    element.options.forEach(item => {
      htmlOptions += `<option value='${item.value}'>${item.label}</option>`
    });
  }
  return `
    <div class="form-group ${element.name}">
      <label for="${element.name}">
        <span class="label" data-i18n="${element.label}">${$.i18n(element.label)}</span>
        ${element.required ? `<sup class="required">*</sup>` : ""}
      </label>
      ${element.type === "textarea" ?
      `<textarea tabindex="${index}" class="form-control" name="${element.name}" data-i18n="[placeholder]${element.placeholder}" placeholder="${$.i18n(element.placeholder)}"></textarea>` :
      element.type === "select" ?
        `<select tabindex="${index}" class="select-district" name="${element.name}" data-required="${element.required ? true : false}" data-i18n="[placeholder]${element.placeholder}" placeholder="${$.i18n(element.placeholder)}"><option></option>${htmlOptions}</select>` :
        `<input tabindex="${index}" data-required="${element.required ? true : false}" class="form-control" name="${element.name}" type="${element.typeInput || "text"}" data-i18n="[placeholder]${element.placeholder}" placeholder="${$.i18n(element.placeholder)}" />`
    }
      <div data-i18n="${element.message}" class="invalid-feedback">
        ${$.i18n(element.message)}
      </div>
    </div >
  `
}